<script>
/**
 * O topo compartilhado dos modais antigos (`woot-modal-header`).
 *
 * Era um titulo preto sobre a mesma folha branca do corpo: nada dizia onde o
 * modal comecava, e ele ficava diferente dos modais que ja reescrevemos, que
 * abrem com a faixa colorida pelo assunto. Trinta e um modais usam este
 * componente — arrumar aqui arruma os trinta e um de uma vez.
 *
 * O tom NAO e enfeite: azul e conversa, ambar e prazo/atencao, rubi e o que
 * destroi ou encerra, iris e IA, teal e o que entra ou da certo, violeta e
 * chat interno. Quem chama diz o assunto; a aparencia sai daqui.
 */
const TONS = {
  azul: '',
  ambar: 'advup-modal__topo--ambar',
  rubi: 'advup-modal__topo--rubi',
  iris: 'advup-modal__topo--iris',
  teal: 'advup-modal__topo--teal',
  violeta: 'advup-modal__topo--violeta',
};

export default {
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
    headerContentValue: {
      type: String,
      default: '',
    },
    headerImage: {
      type: String,
      default: '',
    },
    // Classe do icone (`i-lucide-send`). Sem ela a faixa vem so com o titulo,
    // que ja e o suficiente para ler como nossa.
    icone: {
      type: String,
      default: '',
    },
    tom: {
      type: String,
      default: 'azul',
      validator: valor => Object.keys(TONS).includes(valor),
    },
  },
  computed: {
    classeDoTom() {
      return TONS[this.tom];
    },
  },
};
</script>

<!-- eslint-disable vue/no-unused-refs -->
<!-- Added ref for writing specs -->
<template>
  <div class="mh-topo-bloco">
    <div class="advup-modal__topo" :class="classeDoTom">
      <!-- A marca d'água do topo claro (padrão v2): só aparece dentro de
           `.advup-modais-claros` / `.advup-modal--claro`; no topo antigo some. -->
      <i
        v-if="icone"
        class="advup-modal__marca"
        :class="icone"
        aria-hidden="true"
      />
      <span v-if="icone" class="advup-modal__selo">
        <i :class="icone" />
      </span>
      <h2 data-test-id="modal-header-title" class="advup-modal__titulo">
        {{ headerTitle }}
      </h2>
      <!-- Canto direito da faixa. O X do `woot-modal` e posicionado por
           `ltr:right-2`, uma variante que depende de `dir="ltr"` no documento —
           e este projeto nao declara `dir`. Nos modais estreitos ele cai no
           lugar por acaso; num modal largo (`size="large"`) ele foi parar do
           lado ESQUERDO, por cima do selo. Quem precisa de um X proprio na
           faixa usa este slot e desliga o do modal. -->
      <span v-if="$slots.acoes" class="mh-acoes">
        <slot name="acoes" />
      </span>
    </div>
    <div
      v-if="headerImage || headerContent || $slots.default"
      class="flex flex-col items-start px-8 pt-5 pb-0"
    >
      <img v-if="headerImage" :src="headerImage" alt="No image" />
      <p
        v-if="headerContent"
        data-test-id="modal-header-content"
        class="w-full mb-0 text-sm leading-5 break-words text-n-slate-11"
      >
        {{ headerContent }}
        <span
          v-if="headerContentValue"
          class="text-sm font-semibold text-n-slate-11"
        >
          {{ headerContentValue }}
        </span>
      </p>
      <slot />
    </div>
  </div>
</template>

<style scoped>
/* A faixa e de ponta a ponta: o bloco nao pode ter recuo lateral nenhum. */
/* Empurra o que vier no slot para o fim da faixa. O titulo tem `overflow`
   proprio, entao ele encolhe antes de espremer o botao. */
.mh-acoes {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  flex-shrink: 0;
}

.mh-topo-bloco {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
</style>
